import { computed } from 'vue';
import { SOCIAL_ACCOUNT_ICONS, getSocialIconComponentName } from '../../icons/component-lib.esm3.js';

//
var script = {
  components: {
    ...SOCIAL_ACCOUNT_ICONS
  },
  props: {
    socialAccounts: {
      type: Array,
      default: () => []
    },
    isTop: Boolean
  },
  setup(props) {
    const classes = computed(() => ({
      'site__footer-social--top': props.isTop
    }));
    function getSocialAccountUrl(account) {
      switch (account.type) {
        case 'email':
          return `mailto:${account.url}`;
        case 'phone':
          return `tel:${account.url}`;
        default:
          return account.url;
      }
    }
    return {
      classes,
      getSocialAccountUrl,
      getSocialIconComponentName
    };
  }
};
export { script as default };